import { IAdapter } from "@drl/core/api/adapters/i-adapter";
import { ApiService } from "@drl/core/api/api.service";
import { DelAPICommand } from "@drl/core/core.module";
import {environment} from '@drl/env/environment';

export class DeletePrescriptionFileCommand<T> extends DelAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, id) {
    super(
      apiService,
      adapter,
      `${environment.patientApiUrl}/prescriptions/file-upload/${id}`,
    );
  }
}